const img = require('./backspace.png'); export default img;